// 域名配置
export const DOMAINS = {
  // 博观大模型
  boguan: 'https://www.boguanwenlv.com',
  
  // 文旅数坊
  wenlv: 'https://www.wenlvshufang.com',
  
  // 汇旅云平台
  huilv: 'https://www.huilvyun.com',
};

// 页面路径配置
export const PATHS = {
  // 票务系统
  ticketSys: '/ticketSys',
  
  // 产业监测
  industryMonitor: '/industryMonitor',
  
  // 游系列
  domainTravel: '/solution/domainTravel',
  
  // 旅行社SaaS
  travelAgency: '/travelAgency',
  
  // 全渠道分销
  distribution: '/distribution',
  
  // 灵境智脑
  aiAdhibition: '/aiAdhibition',
  
  // 数字人
  aiEscortSubmit: '/aiEscort?sign=business-process',
  
  // AI伴游
  aiEscort: '/aiEscort',
  
  // AI影旅纪/旅拍换装
  travelPhoto: '/travelPhoto',
  
  // NFC智能客服
  service: '/solution/service',
  
  // 联网问答agent
  onlineQuest: '/onlineQuest',
  
  // 手绘精灵
  aiMarketing: '/aiMarketing',
  
  // 数字供应链产融平台
  supplyChain: '/supplyChain',
  
  // 文旅数据服务
  dataService: '/home/service',
  
  // AI景区运营方案
  scenicOperation: '/solution/scenicOperation',
  
  // AI旅游演出方案
  showOperation: '/solution/showOperation',
  
  // AI旅行社方案
  travelAgencySolution: '/solution/travelAgency',
  
  // AI产业监测方案
  aiMonitorSolution: '/solution/aiMonitorSolution',
  
  // AI全域旅游方案
  aiDomainTravel: '/solution/domainTravel',
  
  // AI数据资产方案
  aiDataAssets: '/solution/aiDataAssets',
};

// 完整URL配置
export const URLS = {
  // 博观大模型
  boguanHome: DOMAINS.boguan,
  
  // 文旅数坊
  wenlvHome: DOMAINS.wenlv,
  wenlvDataService: DOMAINS.wenlv + PATHS.dataService,
  
  // 汇旅云平台各页面
  huilvTicketSys: DOMAINS.huilv + PATHS.ticketSys,
  huilvIndustryMonitor: DOMAINS.huilv + PATHS.industryMonitor,
  huilvDomainTravel: DOMAINS.huilv + PATHS.domainTravel,
  huilvTravelAgency: DOMAINS.huilv + PATHS.travelAgency,
  huilvDistribution: DOMAINS.huilv + PATHS.distribution,
  huilvAiAdhibition: DOMAINS.huilv + PATHS.aiAdhibition,
  huilvAiEscortSubmit: DOMAINS.huilv + PATHS.aiEscortSubmit,
  huilvAiEscort: DOMAINS.huilv + PATHS.aiEscort,
  huilvTravelPhoto: DOMAINS.huilv + PATHS.travelPhoto,
  huilvService: DOMAINS.huilv + PATHS.service,
  huilvOnlineQuest: DOMAINS.huilv + PATHS.onlineQuest,
  huilvAiMarketing: DOMAINS.huilv + PATHS.aiMarketing,
  huilvSupplyChain: DOMAINS.huilv + PATHS.supplyChain,
  huilvScenicOperation: DOMAINS.huilv + PATHS.scenicOperation,
  huilvShowOperation: DOMAINS.huilv + PATHS.showOperation,
  huilvTravelAgencySolution: DOMAINS.huilv + PATHS.travelAgencySolution,
  huilvAiMonitorSolution: DOMAINS.huilv + PATHS.aiMonitorSolution,
  huilvAiDomainTravel: DOMAINS.huilv + PATHS.aiDomainTravel,
  huilvAiDataAssets: DOMAINS.huilv + PATHS.aiDataAssets,
};
